<template>
    <!-- 更改密碼 -->
    <div class="login">
        <navigation-bar Close/>
        <div class="main-content">
            <div class="logo"><Logo/></div>
            <el-form class="textBox" :model="form" ref="loginForm">
                <el-form-item>
                    <el-input placeholder="請輸入舊密碼" v-model="form.oldPassword" type="password"
                              show-password
                              autocomplete="off"
                              maxlength="12"/>
                </el-form-item>
                <el-form-item>
                    <el-input placeholder="請輸入 6-12 碼英數混合" v-model="form.password" type="password"
                              show-password
                              autocomplete="off"
                              maxlength="12"/>
                </el-form-item>
                <el-form-item>
                    <el-input placeholder="請再次確認新密碼" v-model="form.reconfirm" type="password"
                              show-password
                              autocomplete="off"
                              maxlength="12"/>
                </el-form-item>

                <div class="forget" @click="goPhoneVerify">
                    忘記密碼？
                </div>

                <div class="text-center">
                    <h4 class="pt-2">其他設備是否需要登出？</h4>
                    <el-radio-group v-model="radioLogOut" class="radioLogOut">
                        <el-radio :label="1" border round>是</el-radio>
                        <el-radio :label="2" border>否</el-radio>
                    </el-radio-group>
                </div>
            </el-form>

            <div class="btn_box mt-4">
                <el-button round @click="submit()" type="warning">送出</el-button>

            </div>

        </div>
        <!--    <logout :value="logoutDialog" @close="(value) => { logoutDialog = value }" />-->
        <toast/>
        <comm-dialog :value="dialog.isShowDialog" :outerContent="dialog.dialogMsg"  :isCancel="dialog.cancelable" @result="onCommDialogClose"/>
        <loading
                :active.sync=isLoading
                :can-cancel="false"
                :is-full-page="true">
        </loading>
        <div class="brand">
            <span>LIFE LINK 串門子品牌服務系統</span>
        </div>
    </div>
</template>

<script>
    import {checkPassword} from '@/util/validators';
    import Toast from '@/components/Toast.vue';
    import {SHOW_TOAST} from "@/store/mutationTypes";
    import CommDialog from "@/components/CommDialog";
    import Logo from "@/components/Logo";
    import * as constDefine from "@/store/constDefine";
    export default {
        name: "ChangePassword",
        components: {Toast, CommDialog , Logo},
        data() {
            return {
                isLoading: false,
                error: {
                    phone: false,
                    password: false,
                    timer: 0
                },
                form: {
                    oldPassword: '',
                    password: '',
                    reconfirm: ''
                },
                verifyForm: {
                    phone: this.$route.query.phone,
                    verifyCode: this.$route.query.verifyCode,
                },
                //dialog 用
                dialog: {
                    isShowDialog: false,
                    dialogMsg: '',
                    cancelable: false,
                },
                radioLogOut: 0,
            }
        },
        created() {
            // console.log("changePassword created:" + this.verifyForm.phone + ", " + this.verifyForm.verifyCode);
        },
        mounted() {

        },
        methods: {
            /** 顯示訊息 dialog */
            showDialog: function (msg, cancelable = false) {
                this.dialog.cancelable = cancelable;
                this.dialog.dialogMsg = msg;
                this.dialog.isShowDialog = true;
            },

            /** CommDialog 關閉事件 */
            onCommDialogClose(result) {
                this.dialog.isShowDialog = false;
                if (this.radioLogOut === 1) {
                    //清除token
                    this.$auth.clearToken();
                    //清除 fcm device token
                    window.localStorage.setItem(constDefine.KEY_FCM_TOKEN, '');
                    this.$router.replace({name: 'More', params: {from: 'account', message: '已成功登出'}})
                } else {
                    this.goBack();
                }
            },

            /** 送出 更改密碼 */
            submit : function() {

                if (!checkPassword(this.form.password)) {
                    this.$store.commit(SHOW_TOAST, '密碼必須為6-12英文數字混合');
                } else if (this.form.password !== this.form.reconfirm) {
                    //錯誤提示
                    this.$store.commit(SHOW_TOAST, "輸入的新密碼不一致");
                } else if (this.radioLogOut === 0) {
                    this.$store.commit(SHOW_TOAST, "請選擇其他設備是否需要登出");
                } else {
                    let self = this;
                    this.isLoading = true;
                    this.callChangePasswordApi(
                        this.form.oldPassword,
                        this.form.password,
                        this.form.reconfirm)
                    .then( (msg) => {
                        self.isLoading = false;
                        self.showDialog(msg);
                    })
                    .catch( (error) => {
                        self.isLoading = false;
                        self.$store.commit(SHOW_TOAST, error);
                    });
                }
            },

            /** 重設密碼 api */
            callChangePasswordApi(oldPwd, newPwd, confirmPwd) {
                let self = this;
                return new Promise(function(resolve, reject) {
                    self.$http.fetchWithAuth`ChangePassword${{
                        oldPassword: oldPwd,
                        newPassword: newPwd,
                        confirmPassword: confirmPwd,
                        isSignOut: self.radioLogOut === 1,
                    }} ${json => {
                        if (json.status) {
                            //成功
                            // this.$store.commit(SHOW_TOAST, json.message);
                            resolve(json.message);
                        } else {
                            // this.$store.commit(SHOW_TOAST, "重設密碼失敗:" + json.message);
                            reject(json.message);
                        }
                    }}`;
                });
            },

            /** 送出 更改密碼 */
            goBack : function() {
                this.$router.go(-2);
            },
            goPhoneVerify(){
                this.$router.push({ name: 'PhoneVerify' , query: {nextTo: 'ForgotPassword'}})
            },
        }
    }
</script>

<style lang="less" scoped src="@/less/login.less"/>

